import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { GlassCard, PageHeader } from "../components/shared";
import { toast } from "sonner";

export default function Settings() {
    const [form, setForm] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        api.get("/settings").then(({ data }) => setForm(data || {})).catch(() => setForm({}));
    }, []);

    const save = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.patch("/settings", form);
            toast.success("Settings saved");
        } catch (err) { toast.error(formatApiError(err)); }
        finally { setLoading(false); }
    };

    if (!form) return <div className="text-center py-8"><Loader2 className="w-6 h-6 animate-spin mx-auto" /></div>;

    const fields = [
        ["Company name", "company_name"],
        ["Address", "address"],
        ["Logo URL", "logo_url"],
        ["Working hours start", "working_hours_start"],
        ["Working hours end", "working_hours_end"],
        ["Timezone", "timezone"],
        ["Paid leaves / year", "paid_leaves_per_year", "number"],
        ["Sick leaves / year", "sick_leaves_per_year", "number"],
        ["Casual leaves / year", "casual_leaves_per_year", "number"],
    ];

    return (
        <div>
            <PageHeader title="Settings" subtitle="Company profile, working hours and leave policies." testId="settings-header" />
            <GlassCard className="p-6 max-w-3xl">
                <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {fields.map(([label, key, type]) => (
                        <div key={key} className={key === "address" || key === "logo_url" ? "md:col-span-2" : ""}>
                            <Label>{label}</Label>
                            <Input
                                type={type || "text"}
                                value={form[key] ?? ""}
                                onChange={(e) => setForm({ ...form, [key]: type === "number" ? Number(e.target.value) : e.target.value })}
                                className="mt-1"
                                data-testid={`setting-${key}`}
                            />
                        </div>
                    ))}
                    <div className="md:col-span-2">
                        <Button type="submit" disabled={loading} className="rounded-full" data-testid="settings-save">
                            {loading ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}
                            Save changes
                        </Button>
                    </div>
                </form>
            </GlassCard>
        </div>
    );
}
